import * as React from 'react'

export class ComponentDidMount extends React.Component<{
  onMount: () => void
}> {
  componentDidMount() {
    this.props.onMount()
  }

  render() {
    return <> </>
  }
}

export class ComponentWillUnmount extends React.Component<{
  onUnmount: () => void
}> {
  componentWillUnmount() {
    this.props.onUnmount()
  }

  render() {
    return <> </>
  }
}

export class ComponentDidUpdate<A> extends React.Component<{
  value: A
  onUpdate: (oldValue: A, newValue: A) => void
}> {
  componentDidUpdate(prevProps: { value: A }) {
    this.props.onUpdate(prevProps.value, this.props.value)
  }

  render() {
    return <> </>
  }
}
